<template>
  <div class="row">
    <div class="col-12">
      <c-card title="피해내역" class="cardClassDetailForm">
        <template slot="card-button">
          <q-btn-group outline >
            <c-btn
              v-if="!disabled && editable"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="tabParam"
              :mappingType="saveType"
              label="저장"
              icon="save"
              @beforeAction="saveAccident"
              @btnCallback="saveCallback" 
            />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
            <c-textarea
              :disabled="disabled"
              :editable="editable"
              label="재해내역"
              name="materialDamageHistory"
              :rows="2"
              v-model="tabParam.materialDamageHistory">
            </c-textarea>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <c-select
              :editable="editable"
              :disabled="disabled"
              type="edit"
              codeGroupCd="IIM_DAMAGE_CLASS_CD"
              itemText="codeName"
              itemValue="code"
              name="damageClassCd"
              label="사고분류"
              v-model="tabParam.damageClassCd"
            ></c-select>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <c-select
              :editable="editable"
              :disabled="disabled"
              type="edit"
              codeGroupCd="IIM_WOUND_CD"
              itemText="codeName"
              itemValue="code"
              name="woundCd"
              label="상해정도"
              v-model="tabParam.woundCd"
            ></c-select>
          </div>
        </template>
      </c-card>
      <div class="col-lg-12 col-md-12 col-sm-12">
        <c-table
          ref="table"
          title="사고자 인적사항 목록"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="tabParam.accidentVictimModelList"
          :filtering="false"
          :columnSetting="false"
          :checkClickFlag="false"
          :usePaging="false"
          :editable="editable && !disabled"
          noDataLabel="인적피해일 시 사고자 정보를 입력하세요."
          selection="multiple"
          rowKey="victimId"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline>
              <c-btn v-if="editable && !disabled" :showLoading="false" label="내부직원 추가" icon="add" @btnClicked="add" />
              <c-btn v-if="editable && !disabled" :showLoading="false" label="외부직원 추가" icon="add" @btnClicked="addRow" />
              <c-btn v-if="editable && !disabled && tabParam.accidentVictimModelList.length > 0" :showLoading="false"  label="제외" icon="remove" @btnClicked="remove" />
            </q-btn-group>
          </template>
          <template v-slot:customArea="{ props, col }">
            <template v-if="col.name ==='victimName'">
              <c-text-column
                v-if="props.row['insideOutsideTypeCd'] === 'N'"
                :editable="editable"
                :props="props"
                :col="col"
                :disabled="disabled"
                v-model="props.row['victimName']"
                @datachange="datachange(props)"
              />
              <span v-else>
                {{props.row['victimName']}}
              </span>
            </template>
            <template v-if="col.name ==='birthDate'">
              <c-datepicker
                v-if="props.row['insideOutsideTypeCd'] === 'N'"
                class="tableDatepicker"
                :editable="editable"
                :disabled="disabled"
                v-model="props.row['birthDate']"
                @datachange="datachange(props)"
              />
              <span v-else>
                {{props.row['birthDate']}}
              </span>
            </template>
            <template v-if="col.name ==='career'">
              <c-text-column
                v-if="props.row['insideOutsideTypeCd'] === 'N'"
                :editable="editable"
                :props="props"
                :col="col"
                :disabled="disabled"
                v-model="props.row['career']"
                @datachange="datachange(props)"
              />
              <span v-else>
                {{props.row['career']}}
              </span>
            </template>
          </template>
        </c-table>
      </div>
      <div class="col-12">
        <c-upload 
          :attachInfo="attachInfo"
          label="피해정도 관련 사진"
          :editable="editable&&!disabled">
        </c-upload>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import transactionConfig from '@/js/transactionConfig';
import selectConfig from '@/js/selectConfig';
import { uid } from 'quasar'
export default {
  name: 'process-degree-damage',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        iimAccidentId: '',
        stepCd: '',
        count: 0,
        updateBtnProps: {
          data: {
            title: '사고',
            flag: false,
          },
          flagCondition: false,
          btnEditable: false
        }
      }),
    },
    tabParam: {
      type: Object,
      default: () => ({
        materialDamageHistory: '',
        humanDamageHistory: '',
        iimAccidentId: '',
        accidentStatusCd: '',
        accidentVictimModelList: [],
        deleteAccidentVictimModelList: [],
        damageClassCd: null,
        woundCd: null,
      }),
    },
  },
  data() {
    return {
      editable: true,
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'PROCESS_DEGREE_DAMAGE',
        taskKey: '',
      },
      grid: {
        columns: [
        ],
        data: [],
        height: '270px'
      },
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      saveUrl: 'transactionConfig.sop.iim.accident.process.insert.url',
      saveType: 'POST',
      isSave: false,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    disabled() {
      return (this.tabParam.accidentStatusCd === 'ISPC000005' 
          || this.tabParam.approvalStatusCd === 'ASC0000001')
        && !this.popupParam.updateBtnProps.data.flag
    },
  },
  watch: {
    'tabParam.iimAccidentId'() {
      this.setTaskKey();
    },
  },
  methods: {
    init() {
      // role setting
      // url setting
      this.editable = this.$route.meta.editable;
      this.updateUrl = transactionConfig.sop.iim.accident.process.update.damage.url;
      this.getUrl = selectConfig.sop.iim.accident.process.get.url;

      this.$comm.getComboItems('IIM_WORK_DIVISION_CD').then(_result => {
        this.$comm.getComboItems('IIM_WORK_INFO_CD').then(__result => {
          this.$comm.getComboItems('IIM_WORK_YEAR_CD').then(___result => {
            this.grid.columns = [
              {
                name: 'victimName',
                field: 'victimName',
                label: '이름',
                style: 'width:80px',
                type: 'custom',
                align: 'center',
                sortable: false
              },
              {
                name: 'insuranceFlag',
                field: 'insuranceFlag',
                label: '보험적용',
                style: 'width:80px',
                type: "check",
                true: 'Y',
                false: 'N',
                align: 'center',
                sortable: false
              },
              {
                name: 'investFlag',
                field: 'investFlag',
                label: '조사결과표',
                style: 'width:80px',
                type: "check",
                true: 'Y',
                false: 'N',
                align: 'center',
                sortable: false
              },
              {
                name: 'interspersedFlag',
                field: 'interspersedFlag',
                label: '산재안내확인서',
                style: 'width:80px',
                type: "check",
                true: 'Y',
                false: 'N',
                align: 'center',
                sortable: false
              },
              {
                name: 'approveNurseDay',
                field: 'approveNurseDay',
                label: '승인요양일',
                style: 'width:120px',
                align: 'left',
                type: "text",
                sortable: false
              },
              {
                name: 'workYearCd',
                field: 'workYearCd',
                label: '근무년차',
                style: 'width:120px',
                align: 'center',
                type: "select",
                comboItems: ___result,
                sortable: false
              },
              {
                name: 'workDivisionCd',
                field: 'workDivisionCd',
                label: '근무구분',
                style: 'width:120px',
                align: 'center',
                type: "select",
                comboItems: _result,
                sortable: false
              },
              {
                name: 'workInfoCd',
                field: 'workInfoCd',
                label: '교대근무일정보',
                style: 'width:120px',
                align: 'center',
                type: "select",
                comboItems: __result,
                sortable: false
              },
              {
                name: 'degreeDamage',
                field: 'degreeDamage',
                label: '피해상해정도',
                style: 'width:120px',
                type: "textarea",
                align: 'left',
                sortable: false
              },
              {
                name: 'expectTreatmentDate',
                field: 'expectTreatmentDate',
                label: '예상치료기간',
                type: "date",
                range: true,
                style: 'width:150px',
                align: 'center',
                sortable: false
              },
              {
                name: 'attach',
                field: 'attach',
                label: '첨부파일',
                align: 'center',
                style: 'width:10%',
                type: 'attach',
                taskClassCd: 'PROCESS_VICTIM',
                keyText: 'victimId',
                sortable: false,
              },
            ]
          })
        })
      })
      // code setting
      this.setTaskKey();
    },
    setTaskKey() {
      let taskKey = this.tabParam && this.tabParam.iimAccidentId ? this.tabParam.iimAccidentId : '';
      this.attachInfo.taskKey = taskKey
    },
    getDetail() {
      if (this.tabParam.iimAccidentId) {
        this.$http.url = this.$format(this.getUrl, this.tabParam.iimAccidentId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.tabParam.accidentVictimModelList = this.$_.clone(_result.data.accidentVictimModelList);
          this.$_.forEach(this.tabParam.accidentVictimModelList, _item => {
            if (_item.expectTreatmentDate) {
              _item.expectTreatmentDate = _item.expectTreatmentDate.split(',')
            }
          })
        },);
      }
    },
    add() {
      this.popupOptions.title = '사고자 검색'; // 사고자 검색
      this.popupOptions.param = {
        type: 'multiple'
      };
      this.popupOptions.target = () => import(`${'@/pages/common/user/userPop.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeUserPopup;
    },
    closeUserPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, _item => {
          let index = this.$_.findIndex(this.tabParam.accidentVictimModelList, {
            victimUserId: _item.userId,
          });
          if (index === -1) {
            this.tabParam.accidentVictimModelList.splice(0, 0, {
              iimAccidentId: this.tabParam.iimAccidentId,
              victimId: uid(),
              victimUserId: _item.userId,
              victimName: _item.userName,
              birthDate: _item.birthDate,
              insideOutsideTypeName: '내부',
              insideOutsideTypeCd: 'Y',
              age: '',
              career: _item.spotName,
              degreeDamage: '',
              expectTreatmentDate: [],
              actionMatters: '',
              editFlag: 'C',
              interspersedFlag: 'N',
              workDivisionCd: null,
              workInfoCd: null,
              workYearCd: null,
              insuranceFlag: 'N',
              investFlag: 'N',
              aprroveNurseDay: '',
            })
          }
        })
      }
    },
    addRow() {
      this.tabParam.accidentVictimModelList.splice(0, 0, {
        iimAccidentId: this.tabParam.iimAccidentId,
        victimId: uid(),
        victimName: '',
        birthDate: '',
        insideOutsideTypeName: '외부',
        insideOutsideTypeCd: 'N',
        age: '',
        career: '',
        degreeDamage: '',
        expectTreatmentDate: [],
        actionMatters: '',
        editFlag: 'C',
        interspersedFlag: 'N',
        workDivisionCd: null,
        workInfoCd: null,
        workYearCd: null,
        insuranceFlag: 'N',
        investFlag: 'N',
        aprroveNurseDay: '',
      })
    },
    remove() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          this.tabParam.accidentVictimModelList = this.$_.reject(this.tabParam.accidentVictimModelList, { victimId: item.victimId })
          if (!this.tabParam.deleteAccidentVictimModelList) {
              this.tabParam.deleteAccidentVictimModelList = []
          }
          if (this.$_.findIndex(this.tabParam.deleteAccidentVictimModelList, { victimId: item.victimId }) === -1
          && item.editFlag !== 'C') {
            this.tabParam.deleteAccidentVictimModelList.push(item)
          }
          this.tabParam.accidentVictimModelList = this.$_.reject(this.tabParam.accidentVictimModelList, { victimId: item.victimId })
        })
      }
    },
    saveAccident() {
      this.saveUrl = this.updateUrl;
      this.saveType = 'PUT';
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '저장하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$_.forEach(this.tabParam.accidentVictimModelList, _item => {
            if (_item.expectTreatmentDate) _item.expectTreatmentDate = _item.expectTreatmentDate.join();
          })
          this.$_.forEach(this.tabParam.deleteAccidentVictimModelList, _item => {
            if (_item.expectTreatmentDate) _item.expectTreatmentDate = _item.expectTreatmentDate.join();
          })
          this.tabParam.regUserId = this.$store.getters.user.userId
          this.tabParam.chgUserId = this.$store.getters.user.userId
          
          this.isSave = !this.isSave;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    datachange(props) {
      if (props.row['editFlag'] !== 'C') {
        props.row['editFlag'] = 'U'
        props.row['chgUserId'] = this.$store.getters.user.userId
      }
    },
  }
};
</script>
